// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"c1daa1d1","543":"d3747356","659":"2c91a1ff","700":"13f6ed16","765":"1e4c13c7","950":"6a760251"}[chunkId] + ".chunk.js";
};